/**
 * VG2 · Micro8 — logica pura di partizione degli scenari di decisione
 * usata da VALUTA (AlternativesInline) e dalla Scrivania proprietari.
 *
 * Isolata qui per poterla testare senza DOM. Nessun effetto collaterale.
 */

// Un segnaposto (status "da_analizzare") NON è una card reale: niente
// semaforo, voto o numeri; non selezionabile per scelta/confronto.
export const isPlaceholderScenario = (s) => s?.status === "da_analizzare";

// student_rent resta nascosto finché il backend non lo supporta
// (nessun pulsante "Analizza" che non funziona).
export const isUnsupportedPlaceholderKey = (k) =>
  String(k || "").toUpperCase() === "STUDENT_RENT";

/**
 * Divide gli scenari in:
 *  - visible: card reali (NON escluse dall'hero e NON segnaposto);
 *  - placeholders: segnaposto applicabili e supportati (no student_rent).
 */
export function partitionScenarios(scenarios) {
  const list = Array.isArray(scenarios) ? scenarios : [];
  const visible = list.filter(
    (s) => !s.exclude_from_cards && !isPlaceholderScenario(s));
  const placeholders = list.filter(
    (s) => isPlaceholderScenario(s)
           && s.applicable !== false
           && !isUnsupportedPlaceholderKey(s.scenario_key));
  return { visible, placeholders };
}
